import React, { useState, useEffect } from 'react';
import Icon from '@mdi/react';
import { mdiPlay, mdiPause, mdiChevronRight, mdiChevronLeft, mdiChartBar } from '@mdi/js';
import Marquee from 'react-fast-marquee';
import { BQLink } from '../../../../atoms/bqlink';

import './marquee-with-slider.m.css';

const TickerMarquee = ({ items, heading, showToggle = true, speed = 40, isMobile }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  // ✅ Update itemsPerPage based on screen width
  useEffect(() => {
    const updateItemsPerPage = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setItemsPerPage(1); // mobile (marquee anyway)
      } else if (width < 1024) {
        setItemsPerPage(4); // tablet
      } else if (width < 1400) {
        setItemsPerPage(5); // desktop
      } else {
        setItemsPerPage(6); // desktop
      }
    };

    updateItemsPerPage(); // run once
    window.addEventListener('resize', updateItemsPerPage);
    return () => window.removeEventListener('resize', updateItemsPerPage);
  }, []);

  const handleTogglePlay = () => setIsPlaying((prev) => !prev);

  // ✅ Step size = itemsPerPage - 1 (so we overlap 1 item)
  const step = itemsPerPage - 1;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - step + items.length) % items.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + step) % items.length);
  };

  // ✅ Visible items
  const getVisibleItems = () => {
    const visible = [];
    for (let i = 0; i < itemsPerPage; i++) {
      visible.push(items[(currentIndex + i) % items.length]);
    }
    return visible;
  };

  return (
    <div styleName="main-wrapper">
      {/* For Mobile Only  */}
      {isMobile && (
        <>
          <div styleName="marquee-fade-wrapper" className="mobile-only">
            <Marquee pauseOnHover={false} loop={0} gradient={false} speed={speed} play={isPlaying}>
              <div styleName="ticker-container">{items}</div>
            </Marquee>

            <img
              src="/images/left-shadow.png"
              styleName="left-shadow"
              height="32px"
              width="32px"
              alt="shadow"
            />
            <img
              src="/images/right-shadow.png"
              styleName="right-shadow"
              height="32px"
              width="32px"
              alt="shadow"
            />
          </div>

          {heading && (
            <div styleName="heading" className="mobile-only">
              {heading}
            </div>
          )}
          {showToggle && (
            <button onClick={handleTogglePlay} styleName="toggle" className="mobile-only">
              <Icon path={isPlaying ? mdiPause : mdiPlay} size="18px" color="var(--grey-icon)" />
            </button>
          )}
        </>
      )}

      {/* For Desktop Only  */}
      {!isMobile && (
        <div styleName="desk-slider-row" className="desktop-only">
          <img
            src="/images/left-shadow.png"
            styleName="desk-left-shadow"
            height="32px"
            width="32px"
            alt="shadow"
          />
          <Icon path={mdiChartBar} size="16px" color="var(--negative)" />

          <div styleName="slider-section">
            <div styleName="ticker-row">
              {getVisibleItems().map((item, idx) => (
                <div key={idx} styleName="ticker-item">
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div styleName="slider-controls">
            <img
              src="/images/right-shadow.png"
              styleName="desk-right-shadow"
              height="32px"
              width="32px"
              alt="shadow"
            />
            <button onClick={handlePrev} styleName="arrow-btn">
              <Icon path={mdiChevronLeft} size="16px" color="var(--grey-icon)" />
            </button>
            <button onClick={handleNext} styleName="arrow-btn">
              <Icon path={mdiChevronRight} size="16px" color="var(--grey-icon)" />
            </button>
          </div>
          {heading && (
            <BQLink styleName="heading" href="/markets?src=mar_ticker">
              {heading}
            </BQLink>
          )}
        </div>
      )}
    </div>
  );
};

export default TickerMarquee;
